import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ImageSlider from '../components/ImageSlider';
import SEO from '../components/SEO';
import '../App.css';

function Home() {
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    // Add animation classes on scroll
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 150;
        
        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('animate');
        }
      });
    };

    setTimeout(() => {
      handleScroll();
    }, 100);
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const openImageModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    document.body.style.overflow = 'hidden';
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeImageModal();
      }
    };

    if (selectedImage) {
      window.addEventListener('keydown', handleEscape);
      return () => window.removeEventListener('keydown', handleEscape);
    }
  }, [selectedImage]);

  const services = [
    { 
      title: 'Alcohol Addiction', 
      hindi: 'शराब की लत', 
      icon: '🍷', 
      image: '/images/Alcohol addiction 01.jpg',
      description: 'शराब की लत से मुक्ति के लिए व्यापक उपचार कार्यक्रम।',
      methods: [
        'चिकित्सकीय विषहरण (Medical Detoxification)',
        'व्यक्तिगत परामर्श (Individual Counseling)',
        'समूह चिकित्सा (Group Therapy)',
        'पुनर्वास कार्यक्रम (Rehabilitation Program)'
      ]
    },
    { 
      title: 'Cigarette Addiction', 
      hindi: 'सिगरेट की लत', 
      icon: '🚬', 
      image: '/images/Cigarette addiction 1.jpg',
      description: 'सिगरेट की लत से मुक्ति के लिए विशेष कार्यक्रम।',
      methods: [
        'निकोटीन रिप्लेसमेंट थेरेपी (NRT)',
        'व्यवहारिक परामर्श (Behavioral Counseling)',
        'तनाव प्रबंधन (Stress Management)',
        'रिलैप्स रोकथाम (Relapse Prevention)'
      ]
    },
    { 
      title: 'Brown Sugar', 
      hindi: 'ब्राउन शुगर', 
      icon: '💊', 
      image: '/images/Brown sugar.jpg',
      description: 'ब्राउन शुगर की लत से मुक्ति के लिए सुरक्षित उपचार।',
      methods: [
        'सुरक्षित विषहरण (Safe Detox)',
        'व्यक्तिगत उपचार योजना (Personalized Treatment)',
        'मनोचिकित्सा (Psychotherapy)',
        '24/7 चिकित्सकीय देखरेख (24/7 Medical Supervision)'
      ]
    },
    { 
      title: 'Injection Addiction', 
      hindi: 'इंजेक्शन की लत', 
      icon: '💉', 
      image: '/images/new/Injection 01.jpg',
      description: 'इंजेक्शन की लत से मुक्ति के लिए विशेषज्ञ उपचार।',
      methods: [
        'चिकित्सकीय विषहरण (Medical Detox)',
        'संक्रमण नियंत्रण (Infection Control)',
        'व्यक्तिगत परामर्श (Individual Counseling)',
        'पुनर्वास कार्यक्रम (Rehabilitation Program)'
      ]
    },
    { 
      title: 'Dry Drug', 
      hindi: 'सुखा नशा', 
      icon: '🌿', 
      image: '/images/Sukha nasha.jpg',
      description: 'सुखा नशा की लत से मुक्ति के लिए विशेष कार्यक्रम।',
      methods: [
        'मनोवैज्ञानिक मूल्यांकन (Psychological Assessment)',
        'व्यक्तिगत परामर्श (Individual Counseling)',
        'संज्ञानात्मक व्यवहार चिकित्सा (CBT)',
        'रिलैप्स रोकथाम (Relapse Prevention)'
      ]
    },
    { 
      title: 'Solution', 
      hindi: 'सुलेशन', 
      icon: '🧪', 
      image: '/images/Sulesion.jpg',
      description: 'सुलेशन की लत से मुक्ति के लिए व्यापक उपचार।',
      methods: [
        'आपातकालीन चिकित्सा देखभाल (Emergency Medical Care)',
        'विषहरण प्रक्रिया (Detoxification)',
        'मनोवैज्ञानिक सहायता (Psychological Support)',
        'दीर्घकालिक देखभाल (Long-term Care)'
      ]
    }
  ];

  const testimonials = [
    {
      name: 'राज कुमार',
      relation: 'मरीज',
      text: 'निहांश फाउंडेशन ने मेरी जिंदगी बदल दी। मैं 5 साल से शराब की लत से जूझ रहा था, लेकिन यहाँ के डॉक्टरों और परामर्शदाताओं की मदद से मैं पूरी तरह से ठीक हो गया हूँ।',
      rating: 5
    },
    {
      name: 'प्रिया सिंह',
      relation: 'रोगी की बहन',
      text: 'मेरे भाई का इलाज यहाँ हुआ था। टीम बहुत सहायक और पेशेवर है। उन्होंने न केवल मेरे भाई का इलाज किया बल्कि हमारे पूरे परिवार को भी सहायता प्रदान की।',
      rating: 5
    },
    {
      name: 'अमित कुमार',
      relation: 'मरीज',
      text: 'मैं ड्रग्स की लत से मुक्त हो गया हूँ। यहाँ का वातावरण बहुत सकारात्मक है और स्टाफ बहुत देखभाल करता है। मैं सभी को यहाँ आने की सलाह देता हूँ।',
      rating: 5
    }
  ];

  const galleryImages = [
    '/images/01.jpeg',
    '/images/02.jpeg',
    '/images/03.jpeg',
    '/images/04.jpeg',
    '/images/05.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-01.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-03.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-04.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-05.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-06.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-07.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-08.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-09.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-10.jpeg',
    '/events/best=-nasha-mukti-kendra-nihansh-foundation-01.jpeg',
    '/events/best=-nasha-mukti-kendra-nihansh-foundation-02.jpeg'
  ];

  return (
    <div className="App">
      <SEO
        title="Best Nasha Mukti in Patna | Best Nasha Mukti in Bihar | Nihansh Foundation - Nasha Mukti Kendra"
        description="निहांश फाउंडेशन - पटना और बिहार का सर्वोच्च नशा मुक्ति केंद्र। Best Nasha Mukti in Patna, Best Nasha Mukti in Bihar। 24/7 De-addiction Treatment। Call +91 6202410010"
        keywords="nasha mukti, nasha mukiti in patna, nasha mukti in patna, best nasha mukti in bihar, best nasha mukti in patna, best nasha mukti"
      />
      {/* Image Slider */}
      <ImageSlider />

      {/* Hero Content Section */}
      <section className="hero-content-section">
        <div className="hero-content-bg-elements">
          <div className="hero-bg-circle circle-1"></div>
          <div className="hero-bg-circle circle-2"></div>
          <div className="hero-bg-circle circle-3"></div>
        </div>
        <div className="container">
          <div className="hero-content-wrapper">
            <div className="hero-image-section animate-on-scroll animate">
              <div className="hero-main-image">
                <img src="/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-07.jpeg" alt="Nihansh Foundation" />
              </div>
            </div>
            <div className="hero-text-section animate-on-scroll animate">
              <div className="hero-logo">
                <div className="logo-glow">
                  <img src="/logo.png" alt="Nihansh Foundation Logo" className="logo-img" />
                </div>
              </div>
              <h1 className="hero-title">
                <span className="title-gradient">निहांश फाउंडेशन</span>
              </h1>
              <h2 className="hero-subtitle">
                <span className="subtitle-badge">Best Nasha Mukti Kendra in Patna & Bihar (24*7)</span>
              </h2>
              <p className="hero-description">
                नशामुक्त जीवन की ओर यात्रा में आपका स्वागत है। <strong>Nasha Mukti Kendra in Patna</strong> और <strong>Best Nasha Mukti kendra in Bihar</strong> की तलाश करने वालों के लिए निहांश फाउंडेशन आशा की किरण के रूप में खड़ा है। पटना का सर्वश्रेष्ठ <strong>Nasha Mukti Kendra</strong>।
              </p>
              <div className="hero-features">
                <div className="hero-feature-item">
                  <h4>24*7 घर से ले जाने की सुविधा</h4>
                  <p>नियमित व्यायाम और आहार की सुविधा, नियमित योग और प्राणायाम</p>
                </div>
                <div className="hero-feature-item">
                  <h4>24*7 इमरजेंसी सुविधा उपलब्ध</h4>
                  <p>प्रशिक्षित स्टाफ, काउंसलिंग व मोटिवेशन की सुविधा</p>
                </div>
              </div>
              <div className="hero-buttons">
                <a href="tel:+916202410010" className="cta-button primary">
                  <span className="button-icon">📞</span>
                  <span>अभी कॉल करें</span>
                </a>
                <Link to="/about" className="cta-button secondary">
                  <span className="button-icon">ℹ️</span>
                  <span>और जानें</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Nasha Mukti Kendra Patna — landing links */}
      <section className="local-seo-links-section">
        <div className="container">
          <h2 className="section-title animate-on-scroll">Nasha Mukti Kendra in Patna</h2>
          <p className="section-subtitle animate-on-scroll">
            पटना में नशा मुक्ति केंद्र की पूरी जानकारी — सेवाएँ, सुरक्षा और सही केंद्र कैसे चुनें। नीचे दो पेज पढ़ें।
          </p>
          <div className="local-seo-links-grid">
            <article className="local-seo-link-card animate-on-scroll">
              <h3 className="local-seo-card-title">Nasha Mukti Kendra in Patna</h3>
              <p className="local-seo-card-text">
                पटना में नशा मुक्ति केंद्र क्या होता है, कब भर्ती ज़रूरी है, और निहांश फाउंडेशन किन सेवाओं के साथ detox व rehabilitation देता है — संक्षिप्त व स्पष्ट जानकारी।
              </p>
              <Link to="/nasha-mukti-kendra-in-patna" className="local-seo-link-btn">
                पूरा पढ़ें →
              </Link>
            </article>
            <article className="local-seo-link-card animate-on-scroll">
              <h3 className="local-seo-card-title">Best Nasha Mukti Kendra in Patna</h3>
              <p className="local-seo-card-text">
                सही केंद्र की पहचान: मेडिकल टीम, 24×7 केयर, काउंसलिंग और फॉलो-अप। जानें कि निहांश फाउंडेशन को पटना में भरोसेमंद क्यों माना जाता है।
              </p>
              <Link to="/best-nasha-mukti-kendra-in-patna" className="local-seo-link-btn">
                पूरा पढ़ें →
              </Link>
            </article>
          </div>
        </div>
      </section>

      {/* Services We Provide Section */}
      <section className="services-detailed">
        <div className="container">
          <h2 className="section-title animate-on-scroll">Services We Provide</h2>
          <p className="section-subtitle animate-on-scroll">हमारी सेवाएं - विभिन्न प्रकार की नशे की लत के लिए व्यापक उपचार</p>
          <div className="services-detailed-grid">
            {services.map((service, index) => (
              <div 
                key={index} 
                className="service-detailed-card animate-on-scroll" 
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="service-detailed-header">
                  <div className="service-detailed-image">
                    <img src={service.image} alt={service.title} />
                    <div className="service-detailed-overlay"></div>
                  </div>
                  <div className="service-detailed-content">
                    <div className="service-detailed-icon">{service.icon}</div>
                    <h3 className="service-detailed-title">{service.title}</h3>
                    <p className="service-detailed-hindi">{service.hindi}</p>
                  </div>
                </div>
                
                <div className="service-dropdown-content">
                  <div className="service-description">
                    <p>{service.description}</p>
                  </div>
                  
                  <div className="service-methods">
                    <h4>हमारे उपचार के तरीके (Our Treatment Methods)</h4>
                    <ul>
                      {service.methods.map((method, methodIndex) => (
                        <li key={methodIndex}>{method}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="service-cta-buttons">
                    <a href="tel:+916202410010" className="service-cta-btn call">📞 Call Now</a>
                    <Link to="/contact" className="service-cta-btn visit">📍 Visit Us</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <h2 className="section-title animate-on-scroll">Testimonials</h2>
          <p className="section-subtitle animate-on-scroll">हमारे मरीजों और उनके परिवारों की समीक्षाएं</p>
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card animate-on-scroll" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i} className="star">⭐</span>
                  ))}
                </div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-author">
                  <strong>{testimonial.name}</strong>
                  <span>{testimonial.relation}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <h2 className="section-title animate-on-scroll">Gallery</h2>
          <p className="section-subtitle animate-on-scroll">निहांश फाउंडेशन की तस्वीरें</p>
          <div className="gallery-grid">
            {galleryImages.map((image, index) => (
              <div 
                key={index} 
                className="gallery-item animate-on-scroll" 
                style={{ animationDelay: `${index * 0.05}s` }}
                onClick={() => openImageModal(image)}
              >
                <img src={image} alt={`Gallery ${index + 1}`} className="gallery-image" />
                <div className="gallery-overlay">
                  <span className="gallery-icon">🔍</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Modal/Popup */}
      {selectedImage && (
        <div className="image-modal" onClick={closeImageModal}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="image-modal-close" onClick={closeImageModal}>×</button>
            <img src={selectedImage} alt="Gallery" className="image-modal-image" />
          </div>
        </div>
      )}

      {/* FAQ Section */}
      <section 
        className="faq-section"
        style={{
          backgroundImage: "url('/images/new/yoga session.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="container">
          <h2 className="section-title animate-on-scroll">अक्सर पूछे जाने वाले प्रश्न</h2>
          <p className="section-subtitle animate-on-scroll">निहांश फाउंडेशन के बारे में सामान्य प्रश्न</p>
          <div className="faq-container">
            <div className="faq-item animate-on-scroll">
              <h3 className="faq-question">नशा मुक्ति केंद्र क्या है?</h3>
              <p className="faq-answer">
                नशा मुक्ति केंद्र (पुनर्वास केंद्र) एक विशेष सुविधा है जो व्यक्तियों को शराब, ड्रग्स, मारिजुआना और अन्य पदार्थों की लत से उबरने में मदद करती है।
              </p>
            </div>
            <div className="faq-item animate-on-scroll">
              <h3 className="faq-question">आप किस प्रकार की लत का इलाज करते हैं?</h3>
              <p className="faq-answer">
                निहांश फाउंडेशन में, हम पदार्थों की लत की एक विस्तृत श्रृंखला के लिए उपचार प्रदान करते हैं, जिसमें शामिल हैं: शराब की लत, ड्रग्स की लत, व्हाइटनर की लत और कई अन्य।
              </p>
            </div>
            <div className="faq-item animate-on-scroll">
              <h3 className="faq-question">उपचार प्रक्रिया कितने समय तक चलती है?</h3>
              <p className="faq-answer">
                उपचार की अवधि व्यक्ति की स्थिति और उनकी लत की गंभीरता के आधार पर भिन्न होती है। औसतन, निहांश फाउंडेशन पटना में पुनर्वास प्रक्रिया 1 से 6 महीने तक चल सकती है।
              </p>
            </div>
            <div className="faq-item animate-on-scroll">
              <h3 className="faq-question">क्या आपके केंद्र का वातावरण सुरक्षित है?</h3>
              <p className="faq-answer">
                हाँ, हम अपने सभी मरीजों के लिए एक सुरक्षित, स्वच्छ और आरामदायक वातावरण प्रदान करते हैं। हमारा केंद्र आधुनिक सुविधाओं से सुसज्जित है ताकि व्यक्ति अपनी वसूली पर ध्यान केंद्रित कर सकें।
              </p>
            </div>
            <div className="faq-item animate-on-scroll">
              <h3 className="faq-question">क्या आप बाद की देखभाल सहायता प्रदान करते हैं?</h3>
              <p className="faq-answer">
                बिल्कुल। बाद की देखभाल वसूली प्रक्रिया का एक महत्वपूर्ण हिस्सा है। निहांश फाउंडेशन में, हम व्यापक बाद की देखभाल कार्यक्रम प्रदान करते हैं जिसमें निरंतर परामर्श शामिल है।
              </p>
            </div>
            <div className="faq-item animate-on-scroll">
              <h3 className="faq-question">मैं निहांश फाउंडेशन से कैसे संपर्क कर सकता हूँ?</h3>
              <p className="faq-answer">
                यदि आप या आपका कोई प्रियजन लत से जूझ रहा है, तो आप हमसे संपर्क कर सकते हैं:<br />
                <strong>फोन:</strong> <a href="tel:+916202410010" style={{color: '#dc2626', textDecoration: 'none'}}>+91 6202410010</a><br />
                <strong>पता:</strong> Krishna Niketan, School Road, Near Bajrangi Chowk, Jakariyapur, Zero Mile, Pahari, Patna, Bihar 800030, India<br />
                <strong>ईमेल:</strong> <a href="mailto:nihanshfoundation@gmail.com" style={{color: '#dc2626', textDecoration: 'none'}}>nihanshfoundation@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SEO Content - Nasha Mukti Keywords for Google Search */}
      <section className="seo-content-section" style={{ padding: '40px 0', background: '#f8fafc' }}>
        <div className="container">
          <div className="animate-on-scroll" style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '16px', color: '#1e293b' }}>
              Best Nasha Mukti in Patna | Nasha Mukti in Bihar
            </h2>
            <p style={{ lineHeight: 1.8, color: '#475569' }}>
              <strong>निहांश फाउंडेशन</strong> पटना और बिहार में <strong>Best Nasha Mukti kendra in Patna</strong> और <strong>Nasha Mukti kendra</strong> सेवाएं प्रदान करता है। 
              यदि आप <strong>Nasha Mukti Kendra in Patna</strong> या <strong>Best Nasha Mukti kendra in Bihar</strong> ढूंढ रहे हैं, 
              तो हमारा केंद्र आपके लिए सही विकल्प है। शराब, ड्रग्स और अन्य नशों की लत से मुक्ति के लिए 24/7 कॉल करें।
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-background">
          <img 
            src="/images/Say no to drugs 1.jpg" 
            alt="Say No to Drugs" 
            className="cta-bg-image" 
          />
          <div className="cta-overlay"></div>
        </div>
        <div className="cta-content animate-on-scroll">
          <div className="cta-icon">
            <img 
              src="/images/No drugs.jpeg" 
              alt="No Drugs" 
              className="cta-icon-image" 
            />
          </div>
          <h2 className="cta-title">नशे से मुक्त जीवन पाने के लिए आज ही हमें कॉल करें</h2>
          <p className="cta-text">
            पुनर्प्राप्ति के लिए अपनी व्यक्तिगत यात्रा शुरू करने के लिए तैयार हैं? आज ही निहांश फाउंडेशन से संपर्क करें।
          </p>
          <div className="cta-buttons">
            <a href="tel:+916202410010" className="cta-button primary large">+91 6202410010</a>
            <Link to="/contact" className="cta-button secondary large">संपर्क करें</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
